import { ProductPriceProps } from '@teko/ecommerce/mobile';
import { getDiscountPercent, checkExpiryDateTimestamp } from './common';
import { BannerEntity } from '../types';
import { DiscoveryProduct } from '@teko/discovery';

export const getFrame = (
  tags: string[],
  frames: BannerEntity[],
): string | undefined => {
  const ids: number[] = [];
  tags.forEach((el) => {
    const matchReg = el.match(/^frame_(\d+)_.+/);
    if (matchReg && matchReg[1] && !isNaN(parseInt(matchReg[1]))) {
      ids.push(parseInt(matchReg[1]));
    }
  });
  const frame = frames.find(
    (fr) =>
      ids.includes(fr.id) && checkExpiryDateTimestamp(fr.startDate, fr.endDate),
  );
  return frame ? frame.image : undefined;
};

//Convert discovery price format to component price format
export const convertPrice = (product: DiscoveryProduct): ProductPriceProps => {
  const { prices } = product;
  const price = parseInt(prices?.[0]?.latestPrice);
  const supplierRetailPrice = parseInt(prices?.[0]?.supplierRetailPrice);
  const listedPrice = price > supplierRetailPrice ? null : supplierRetailPrice;
  const discount = getDiscountPercent(price, listedPrice);
  return {
    price: isNaN(price) ? undefined : price,
    listedPrice: isNaN(listedPrice) ? undefined : listedPrice,
    discount: isNaN(discount) ? undefined : discount,
  };
};

export const isDisplayUomByTenant = (tenant: string): boolean => {
  switch (tenant) {
    case 'soibien':
      return true;
    default:
      return false;
  }
};

export const isVariantUrlGrouped = (canonical: string) => {
  // some product need to group all skus into a single url
  // we don't have that flag returned to client
  // so rely on url pattern for now, which may not be
  // very reliable in the future
  // for such product, canonical is /product-name--p<productId>
  return canonical?.indexOf('--p') >= 0;
};
